module.exports = __webpack_public_path__ + "static/media/SickLeave.3a6a30cb.svg";